import {useMemo} from 'react'
import {useQuery} from 'react-query'
import {ThemeEditModalForm} from './ThemeEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneByIdbylang } from '../../../../services/common_requests'
import { Theme, initialTheme } from '../core/_models'

/** Référence stable — éviter de recréer l'objet à chaque render (sinon Formik avec enableReinitialize efface la saisie). */
const THEME_MODAL_CREATE_TEMPLATE: Theme = {
  ...initialTheme,
  _id: undefined,
  translations: (initialTheme.translations || [{ language: 'en', name: '' }]).map((t) => ({...t})),
}

const ThemeEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const themeLoadingShell = useMemo((): Theme => {
    return {
      ...THEME_MODAL_CREATE_TEMPLATE,
      _id: itemIdForUpdate,
      translations: THEME_MODAL_CREATE_TEMPLATE.translations.map((t) => ({...t})),
    }
  }, [itemIdForUpdate])

  const {
    isLoading,
    data: Theme,
    error,
  } = useQuery(
    `${QUERIES.THEMES_LIST}-theme-${itemIdForUpdate}`,
    () => {
      return getOneByIdbylang(`/themes/${itemIdForUpdate}?language=all`)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (_err) => {
        setItemIdForUpdate(undefined)
      },
    },
  )

  if (!itemIdForUpdate) {
    return <ThemeEditModalForm isThemeLoading={isLoading} Theme={THEME_MODAL_CREATE_TEMPLATE} />
  }

  if (enabledQuery && (isLoading || (!error && !Theme))) {
    return <ThemeEditModalForm isThemeLoading={true} Theme={themeLoadingShell} />
  }

  if (!isLoading && !error && Theme) {
    return <ThemeEditModalForm isThemeLoading={false} Theme={Theme} />
  }

  return <ThemeEditModalForm isThemeLoading={false} Theme={themeLoadingShell} />
}

export {ThemeEditModalFormWrapper}
